import React, { useState } from 'react';
import FormField from '../ui/FormField';
import Input from '../ui/Input';
import './PasswordField.css';

function PasswordField({
  id,
  label,
  value,
  onChange,
  placeholder = 'Enter password',
  autoComplete = 'current-password',
  required = false,
  disabled = false,
  error,
  hint,
}) {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (disabled) return;
    setIsVisible((current) => !current);
  };

  return (
    <FormField label={label} htmlFor={id} required={required} error={error} hint={hint}>
      <div className="password-input">
        <Input
          id={id}
          type={isVisible ? 'text' : 'password'}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          autoComplete={autoComplete}
          disabled={disabled}
          error={Boolean(error)}
          className="password-input__field"
        />
        <button
          type="button"
          className="password-input__toggle"
          onClick={toggleVisibility}
          aria-label={isVisible ? 'Hide password' : 'Show password'}
          aria-pressed={isVisible}
          disabled={disabled}
        >
          {isVisible ? 'Hide' : 'Show'}
        </button>
      </div>
    </FormField>
  );
}

export default PasswordField;
